import React from 'react';
import {CSVDownload} from 'react-csv';
class ExportData extends React.Component{
constructor(props){
  super(props);
  this.state = {
    csvHeader:'',
    csvContent:'',
    childDta:false,
    collectorDta:false,
    classesDta:false,
  }
}





getClassesData = async() =>{
//const arrd = [['firstname', 'lastname', 'email']];

fetch('https://schoolportal.appsdesign.co.za/get_class/' + await localStorage.getItem('schoolToken'))
.then((response) => response.json())
.then((responseJson) => {
console.log(responseJson[0])
  this.setState({
    csvHeader: responseJson,
    classesDta:true,
}, function(){

  });
console.log(this.state.csvHeader)
})
.catch((error) =>{
  console.error(error);
});

}







getCollectordData = async() =>{
//const arrd = [['firstname', 'lastname', 'email']];

fetch('https://schoolportal.appsdesign.co.za/get_collector/' + await localStorage.getItem('schoolToken'))
.then((response) => response.json())
.then((responseJson) => {
console.log(responseJson[0])
  this.setState({
    csvHeader: responseJson,
    collectorDta:true,
}, function(){

  });
console.log(this.state.csvHeader)
})
.catch((error) =>{
  console.error(error);
});

}




getChildData = async () =>{
//const arrd = [['firstname', 'lastname', 'email']];

fetch('https://schoolportal.appsdesign.co.za/get_child/' + await localStorage.getItem('schoolToken'))
.then((response) => response.json())
.then((responseJson) => {
console.log(responseJson[0])
  this.setState({
    csvHeader: responseJson,
    childDta:true,
}, function(){

  });
console.log(this.state.csvHeader)
})
.catch((error) =>{
  console.error(error);
});

}

render(){
let csvData ='';

  if(this.state.csvHeader !== ''){
if(this.state.childDta){
  csvData = this.state.csvHeader.map(val =>{

var collectors = JSON.stringify(val.collectors)
collectors = collectors.replace("[","");
collectors = collectors.replace("]","");
collectors = collectors.replace(/{/g," ");
collectors = collectors.replace(/},/g,"==");
collectors = collectors.replace(/,/g,"+");
collectors = collectors.replace(/"/g,"");

  return {
   _id:val._id,
   childSchool:val.childSchool,
   pnum:val.pnum,
   childname:val.childname,
   childsurname:val.childsurname,
   childclass:val.childclass,
   childgender:	val.childgender,
   childcomments:val.childcomments,
   collectors:collectors,
   absent:'false',
   collected:'false'
 };

  })
  this.setState({childDta:false})
}
else{
  csvData = this.state.csvHeader;
}

}
else {
  csvData = '';
}
return(
    <div className="ma2 pa2 br3 shadow-4" style={{display:'flex', flexDirection:'column', justifyConytent:'center', alignItems:'center',margin:100,backgroundColor:'white'}}>
<h1> Export data </h1>
<span style={{margin:10}}>Select dats to export to csv format that you can import into MS Excel(Windows) or Numbers(Mac) etc.</span>
<div>
<button onClick={this.getChildData}
style={{
  color:'white',
  textDecoration:'none',
  padding:20,
  fontSize:20,
  backgroundColor:'black',
  width:200
}}>

Children Data</button>


{
  this.state.childDta ?
<CSVDownload data={csvData} target="_blank" />
: null
}
</div>

<div style={{marginTop:20}}>
<button onClick={this.getCollectordData}
style={{
  color:'white',
  textDecoration:'none',
  padding:20,
  fontSize:20,
  backgroundColor:'black',
  width:200
}}>Collectors Data</button>


{
  this.state.collectorDta ?
<CSVDownload data={csvData} target="_blank" />
: null
}

</div>









<div style={{marginTop:20}}>

<button onClick={this.getClassesData}
style={{
  color:'white',
  textDecoration:'none',
  padding:20,
  fontSize:20,
  backgroundColor:'black',
  width:200
}}>Classes Data</button>



{
  this.state.classesDta ?
<CSVDownload data={csvData} target="_blank" />
: null
}


</div>




</div>
)

}

}

export default ExportData;



// WEBPACK FOOTER //
// ./src/components/ExportData/ExportData.js